import { TestDefinitionCreateInput, TestDefinitionUpdateInput } from "../../api";
import { builder } from "../builder";

builder.input<TestDefinitionCreateInput>("TestDefinitionCreateInput", {
  name: builder.string().required(),
  description: builder.array().nullable(),
});

builder.input<TestDefinitionUpdateInput>("TestDefinitionUpdateInput", {
  name: builder.string(),
  description: builder.array(),
});
